<ng-container *transloco="let t; read: 'basket'">
  <kendo-grid
    [data]="data"
    [rowClass]="rowClass"
    [skip]="skip"
    [pageSize]="pageSize"
    [pageable]="true"
    [loading]="loading"
    (pageChange)="onPageChange($event)"
    (remove)="removeHandler($event)"
    [sortable]="{allowUnsort: true}">

    <kendo-grid-column
      field="product.name"
      [title]="t('productName')"
      media="(min-width: 993px)">
      <ng-template kendoGridCellTemplate let-dataItem>
        {{dataItem.product?.name}}
        @if (!dataItem.product?.isActive && dataItem.product?.inactiveReason) {
          <span class="tooltipContainer">
            <span [attr.tooltip]="dataItem.product.inactiveReason" flow="right" class="tooltipContainer">
              <img class="tooltipIcon" src="../assets/icons/information-icon.svg">
            </span>
          </span>
        }
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column
      field="product.internalNumber"
      [title]="t('procutInternalNumber')"
      media="(min-width: 993px)">
    </kendo-grid-column>

    <kendo-grid-column
      field="quantity"
      [title]="t('basketQuantity')"
      media="(min-width: 993px)">
      <ng-template kendoGridCellTemplate let-dataItem>
        <kendo-numerictextbox
          [style.width.px]="80"
          [autoCorrect]="true"
          [value]=dataItem.quantity
          #newQuantity
          (blur)="updateQuantity(newQuantity.value, dataItem)"
          [min]="1"
          format="n0"
          >
        </kendo-numerictextbox>
      </ng-template>
    </kendo-grid-column>

    <!-- MOBILE GRID STARTS HERE -->

    <kendo-grid-column media="(max-width: 992px)">
      <ng-template kendoGridCellTemplate let-dataItem>
        <h4 class="mobileGridHeader">{{t('productName')}}</h4>
        <span>{{dataItem.product.name}}</span>
        @if (!dataItem.product?.isActive && dataItem.product?.inactiveReason) {
          <span class="tooltipContainer">
            <span [attr.tooltip]="dataItem.product.inactiveReason" flow="right" class="tooltipContainer">
              <img class="tooltipIcon" src="../assets/icons/information-icon.svg">
            </span>
          </span>
        }
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column media="(max-width: 992px)">
      <ng-template kendoGridCellTemplate let-dataItem>
        <h4 class="mobileGridHeader">{{t('procutInternalNumber')}}</h4>
        <span>{{dataItem.product.internalNumber}}</span>
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column media="(max-width: 992px)">
      <ng-template kendoGridCellTemplate let-dataItem>
        <h4 class="mobileGridHeader">{{t('basketQuantity')}}</h4>
        <kendo-numerictextbox
          [style.width.px]="80"
          [autoCorrect]="true"
          [value]=dataItem.quantity
          #newQuantity
          (blur)="updateQuantity(newQuantity.value, dataItem)"
          [min]="1"
          format="n0">
        </kendo-numerictextbox>
      </ng-template>
    </kendo-grid-column>

    <!-- MOBILE GRID ENDS HERE -->

    <kendo-grid-command-column>
      <ng-template kendoGridCellTemplate let-dataItem>
        <button
          kendoGridRemoveCommand
          loadingIndication="/basketitems/deletebasketitem/{{dataItem.id}}"
          [attr.tooltip]="t('delete')"
          flow="up"
          class="actionIcon">
          <img src="../../../assets/icons/delete-icon.svg">
        </button>
      </ng-template>
    </kendo-grid-command-column>

    <ng-template kendoGridNoRecordsTemplate>
      <div class="text pl">{{t('noResults')}}</div>
    </ng-template>

    <ng-template kendoGridLoadingTemplate>
      <div class="k-loading-color"></div>
      <div class="loading-container">
        <kendo-loader type="converging-spinner" size="large"></kendo-loader>
      </div>
    </ng-template>

    <ng-template
      let-totalPages="totalPages"
      let-currentPage="currentPage"
      kendoPagerTemplate>
      <div class="flex gridPagination">
        <div class="flex flexDirRow gridRow">
          <kendo-pager-prev-buttons></kendo-pager-prev-buttons>
          <kendo-pager-numeric-buttons
            [buttonCount]="5">
          </kendo-pager-numeric-buttons>
          <kendo-pager-next-buttons></kendo-pager-next-buttons>
        </div>
        <div class="gridRow">
          <kendo-buttongroup [selection]="'single'" id="pageBtnGroup">
            <button (click)="onPageSizeChange(pageSizes.Small)" kendoButton
              [selected]="gridState.pageSize === pageSizes.Small" [toggleable]="true">
              {{ pageSizes.Small }}
            </button>
            <button (click)="onPageSizeChange(pageSizes.Medium)" kendoButton
              [selected]="gridState.pageSize === pageSizes.Medium" [toggleable]="true">
              {{ pageSizes.Medium }}
            </button>
            <button (click)="onPageSizeChange(pageSizes.Large)" kendoButton
              [selected]="gridState.pageSize === pageSizes.Large" [toggleable]="true">
              {{ pageSizes.Large }}
            </button>
          </kendo-buttongroup>

          <button kendoButton [title]="t('refresh')" class="reloadIcon" (click)="onGridReload()">
            <img class="actionIcon" src="../assets/icons/reload.svg">
          </button>
        </div>
      </div>
    </ng-template>

  </kendo-grid>
</ng-container>